export class ProjetoFavoritoDto {
  id: number;
  projetoId: number;
  usuarioId: number;
  dataCriacao: Date;
}
